import styled from '@emotion/styled'
import { ActionButton } from 'modules/ui/atoms/ActionButton'
import { DEFAULT_FONT_STYLES, DEFAULT_THEME_COLORS } from 'css/theme'
import {
  PrevStepButton,
  STEP_LAYOUT_HEIGHT,
  STEP_LAYOUT_LARGE_WIDTH,
  STEP_LAYOUT_SMALL_WIDTH,
} from '../shared/shared-step-layout.styled'

export const Outer = styled.div`
  width: ${STEP_LAYOUT_SMALL_WIDTH};
  max-height: ${STEP_LAYOUT_HEIGHT};
  height: calc(100vh - 82px);
  max-width: 100vw;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: white;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;

  @media (min-width: ${STEP_LAYOUT_SMALL_WIDTH}) {
    border-radius: 20px;
  }

  @media (min-width: 784px) {
    width: ${STEP_LAYOUT_LARGE_WIDTH};
  }
`

export const Top = styled.div`
  padding: 24px;
  border-bottom: 1px #eeeeee solid;
  color: ${DEFAULT_THEME_COLORS['--theme-color--neutral-20']};
`

export const TopName = styled.div`
  font-size: ${DEFAULT_FONT_STYLES['--theme-font--title-page-sm__font-size']};
  font-weight: ${DEFAULT_FONT_STYLES['--theme-font--title-page-sm__font-weight']};
  line-height: ${DEFAULT_FONT_STYLES['--theme-font--title-page-sm__line-height']};
`

export const TopAmount = styled.div`
  font-size: ${DEFAULT_FONT_STYLES['--theme-font--body-default__font-size']};
`

export const Bottom = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
`

interface MainProps {
  title: string
  children: React.ReactNode
  hideBackButton?: boolean
  backButtonDataId?: string
  hideHeader?: boolean
}

export const Main = ({
  title,
  children,
  hideBackButton = false,
  backButtonDataId = '',
  hideHeader = false,
}: MainProps) => {
  return (
    <MainOuter>
      {!hideHeader && (
        <MainHeader>
          {hideBackButton ? null : (
            <PrevStepButton iconName="arrow_back" size="md" dataId={backButtonDataId} />
          )}
          <MainHeaderTitle>{title}</MainHeaderTitle>
        </MainHeader>
      )}
      <MainBody>{children}</MainBody>
    </MainOuter>
  )
}

export const MainOuter = styled.div`
  flex: 1;
  display: flex;
  overflow-y: auto;
  flex-direction: column;
`

const MainHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 24px 24px 12px;
`

const MainHeaderTitle = styled.div`
  flex: 1;
  text-align: center;
  margin-top: 20px;
  color: ${DEFAULT_THEME_COLORS['--theme-color--neutral-20']};
  font-size: ${DEFAULT_FONT_STYLES['--theme-font--title-medium-page__font-size']};
  font-weight: ${DEFAULT_FONT_STYLES['--theme-font--title-page-sm__font-weight']};
  line-height: ${DEFAULT_FONT_STYLES['--theme-font--title-page-sm__line-height']};
`

const MainBody = styled.div`
  flex: 1;
  display: flex;
  padding: 12px 24px;
  justify-content: center;
`

interface FooterProps {
  children: React.ReactNode
}

export const Footer = ({ children }: FooterProps) => {
  return (
    <StyledFooter>
      <FooterInner>{children}</FooterInner>
    </StyledFooter>
  )
}

export const StyledFooter = styled.div`
  gap: 24px;
  display: flex;
  padding: 24px;
  justify-content: center;
`

export const FooterInner = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  width: 100%;
  max-width: 460px;
  @media (max-width: 767px) {
    flex-direction: column;
    justify-content: center;
  }
`

export const FooterButton = styled(ActionButton)``
